import { useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface XProfile {
  kind: "profile";
  handle: string;
  name: string;
  bio: string | null;
  avatar: string | null;
  banner: string | null;
  followers: number | null;
  following: number | null;
  tweets: number | null;
  verified: boolean;
  url: string;
}

export interface XTweet {
  kind: "tweet";
  id: string;
  url: string;
  text: string;
  likes: number;
  retweets: number;
  replies: number;
  views: number | null;
  createdAt: string;
  media: string | null;
  author: {
    handle: string;
    name: string;
    avatar: string | null;
    followers: number | null;
    verified: boolean;
  };
}

export type XSearchResult = XProfile | XTweet;

export const useXSearch = () => {
  const [data, setData] = useState<XSearchResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const search = useCallback(async (params: { handle?: string; tweetId?: string }) => {
    setLoading(true);
    setError(null);
    setData(null);
    try {
      const { data: res, error: err } = await supabase.functions.invoke("x-search", { body: params });
      if (err) throw err;
      if ((res as any)?.error) throw new Error((res as any).error);
      setData(res as XSearchResult);
    } catch (e) {
      const msg = e instanceof Error ? e.message : "Lookup failed";
      setError(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => { setData(null); setError(null); }, []);

  return { data, loading, error, search, reset };
};
